package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.AlignItems.CENTER
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.*
import com.downdogapp.client.Strings.BACK
import com.downdogapp.client.api.LinkType.AMAZON
import com.downdogapp.client.api.LinkType.ITUNES
import com.downdogapp.client.api.LinkType.SPOTIFY
import com.downdogapp.client.controllers.SongViewController
import com.downdogapp.client.resources.Images
import com.downdogapp.client.widget.*
import com.downdogapp.client.widget.StructuredRow.Companion.leftIconRow

actual class SongView actual constructor(
  private val controller: SongViewController
) : TopLevelView(), View {

  override val root = controllerView {
    bg = if (AppPage.displayingAbovePlayback) {
      background(image = postPracticeBackgroundImage) {
        filter = Filter.blur(px(10))
      }
    } else {
      background(true)
    }
    fg = foreground(!AppPage.displayingAbovePlayback) {
      centeredColumnView {
        pageHeader(onBackClicked = controller::onBackClicked)

        horizontalFlexBox(verticalAlign = CENTER) {
          marginLeft = HORIZONTAL_CONTENT_GUTTER_PX
          marginBottom = px(14)
          marginTop = px(14)

          imageView(width = 50, height = 50) {
            src = MANIFEST.artworkUrlPrefix + controller.song.artwork
          }

          verticalFlexBox {
            flexGrow = 1.0
            marginLeft = px(15)

            label(controller.song.title, 18) {
              marginBottom = px(7)
            }
            label(controller.song.artist, 14)
          }
        }

        separator()

        tableView(::getContents)

        roundedTextButton(
          text = BACK,
          marginHorizontal = HORIZONTAL_CONTENT_GUTTER_PX,
          clickFn = controller::onBackClicked
        ) {
          marginTop = px(6)
        }
      }
    }
  }

  private fun getContents() = TableContents(
    rows = listOfNotNull(
      controller.song.itunesUrl?.let { url ->
        leftIconRow(
          image = Images.ITUNES_ICON,
          text = Strings.OPEN_IN_ITUNES,
          clickFn = { controller.linkClicked(url, ITUNES) }
        )
      },
      controller.song.spotifyUrl?.let { url ->
        leftIconRow(
          image = Images.SPOTIFY_ICON,
          text = Strings.OPEN_IN_SPOTIFY,
          clickFn = { controller.linkClicked(url, SPOTIFY) }
        )
      },
      controller.song.amazonUrl?.let { url ->
        leftIconRow(
          image = Images.AMAZON_ICON,
          text = Strings.OPEN_IN_AMAZON,
          clickFn = { controller.linkClicked(url, AMAZON) }
        )
      }
    ),
    separator = rightSeparator
  )
}
